function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import emitter from '../../utils/emitter';
import { onKeyDown } from '../../utils/events';
import './styles';

var PredictionItem = /*#__PURE__*/function (_Component) {
  _inheritsLoose(PredictionItem, _Component);

  function PredictionItem(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.onEmittedFocus = _this.onEmittedFocus.bind(_assertThisInitialized(_this));
    _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_this)); // mouse events

    _this.onClick = _this.onClick.bind(_assertThisInitialized(_this)); // keyboard events

    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_this));
    _this.onEnterKey = _this.onEnterKey.bind(_assertThisInitialized(_this));
    _this.item = /*#__PURE__*/React.createRef();
    _this.eventSubscriptions = [];

    _this.eventSubscriptions.push(emitter.addListener('focus', _this.onEmittedFocus));

    _this.eventSubscriptions.push(emitter.addListener('enterKey', _this.onEnterKey(emitter)));

    _this.state = {
      focusedId: null,
      menuOpen: false
    };
    return _this;
  } // begin lifecycle methods


  var _proto = PredictionItem.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.eventSubscriptions.map(this.unsubscribe);
  } // end lifecycle methods
  ;

  _proto.unsubscribe = function unsubscribe(subscription) {
    subscription.remove();
  };

  _proto.onEmittedFocus = function onEmittedFocus(id) {
    var focus = id === this.props.prediction.__id__;
    this.setState({
      focusedId: id
    });

    if (focus) {
      this.item.current.focus();
    }
  };

  _proto.onFocus = function onFocus(emitterImpl) {
    var _this2 = this;

    return function () {
      emitterImpl.emit('focus', _this2.props.prediction.__id__);
    };
  } // begin mouse events
  ;

  _proto.onClick = function onClick(emitterImpl) {
    var _this3 = this;

    return function () {
      _this3.onFocus();

      emitterImpl.emit('identifySelection', _this3.state.focusedId);
    };
  } // end mouse events
  // begin keyboard events
  ;

  _proto.onKeyDown = function onKeyDown(onKeyDownImpl) {
    var _this4 = this;

    return function (ev) {
      onKeyDownImpl(_this4.props.menuOpen, ev);
    };
  };

  _proto.onEnterKey = function onEnterKey(emitterImpl) {
    var _this5 = this;

    return function () {
      emitterImpl.emit('identifySelection', _this5.state.focusedId);
    };
  } // end keyboard events
  ;

  _proto.boldMatchingParts = function boldMatchingParts(re, something) {
    var result = [];
    var splitted = something.split(re);
    var count = 0;
    result.push( /*#__PURE__*/React.createElement(React.Fragment, {
      key: "rt-item-key-" + ++count
    }, splitted.shift()));

    if (splitted.length > 0) {
      var matched = something.match(re);
      result = splitted.reduce(function (a, c, i) {
        a.push( /*#__PURE__*/React.createElement("span", {
          key: "rt-item-key-" + ++count,
          className: 'react-typeahead--matched'
        }, matched[i]));
        a.push( /*#__PURE__*/React.createElement(React.Fragment, {
          key: "rt-item-key-" + ++count
        }, c));
        return a;
      }, result);
    }

    return result;
  };

  _proto.renderPredictionString = function renderPredictionString(text) {
    var _this$props = this.props,
        useBolding = _this$props.useBolding,
        input = _this$props.input;

    if (useBolding && input && input.length > 0) {
      return this.boldMatchingParts(new RegExp(input, 'ig'), text);
    }

    return text;
  };

  _proto.render = function render() {
    var prediction = this.props.prediction;
    return /*#__PURE__*/React.createElement("li", {
      className: "typeahead-prediction-item fds-list-item",
      onClick: this.onClick(emitter),
      onFocus: this.onFocus(emitter),
      onKeyDown: this.onKeyDown(onKeyDown),
      onMouseEnter: this.onFocus(emitter),
      ref: this.item,
      role: "menuitem",
      tabIndex: "0" // this allows the <li> to be focusable which is critical to make keyboard events work

    }, this.renderPredictionString(prediction.text));
  };

  return PredictionItem;
}(Component);

PredictionItem.propTypes = {
  /** Flag to indicate whether the menu is open. */
  // this is important for handling keyboard events
  menuOpen: PropTypes.bool,

  /** the input the user has typed so far */
  input: PropTypes.string,

  /** True of we should bold the parts of the string that match the input. */
  useBolding: PropTypes.bool.isRequired,

  /** The prediction item data */
  prediction: PropTypes.shape({
    __id__: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  }).isRequired
};
export default PredictionItem;
//# sourceMappingURL=PredictionItem.js.map